import {
  ExclamationTriangleIcon,
  MagnifyingGlassIcon,
  QuestionMarkCircleIcon,
  ServerIcon,
  WifiIcon,
} from '@heroicons/react/24/outline';
import { AxiosError, isAxiosError } from 'axios';

import { useTranslation } from 'react-i18next';

function isNetworkError(err: AxiosError) {
  return !!err.isAxiosError && !err.response;
}
export const ErrorComponent = ({ error }: { error: unknown }) => {
  const { t } = useTranslation('designSystem');
  const errorMessage = () => {
    if (isAxiosError(error)) {
      if (isNetworkError(error)) {
        return (
          <>
            <WifiIcon className="h-9 w-9 text-gray-400 dark:text-gray-500" />
            {t('troubleConnectingToTheServer')}
          </>
        );
      }
      switch (error.response?.status) {
        case 404:
          return (
            <>
              <MagnifyingGlassIcon className="h-9 w-9 text-gray-400 dark:text-gray-500" />
              {t('couldnFindWhatYouAreLookingFor')}
            </>
          );
        case 403:
          return (
            <>
              <ExclamationTriangleIcon className="h-9 w-9 text-gray-400 dark:text-gray-500" />
              {t('accessToTheResourceIsForbidden')}
            </>
          );
        case 400:
          return (
            <>
              <ExclamationTriangleIcon className="h-9 w-9 text-gray-400 dark:text-gray-500" />
              {t('badRequestTheRequestCouldNotBe')}
            </>
          );

        default:
          return (
            <>
              <ServerIcon className="h-9 w-9 text-gray-400 dark:text-gray-500" />
              {t('internalServerErrorPleaseTryAgainLater')}
            </>
          );
      }
    }

    return (
      <>
        <QuestionMarkCircleIcon className="h-9 w-9 text-gray-400 dark:text-gray-500" />
        {t('somethingWentWrongPleaseTryAgainLater')}
      </>
    );
  };
  return (
    <div className="flex h-full w-full flex-grow flex-col items-center justify-center bg-gray-50 dark:bg-gray-800 p-4 text-center text-gray-600 dark:text-gray-400">
      {errorMessage()}
    </div>
  );
};
